<template>
  <div class="collection-component">
    <v-loader v-if="isSettingsLoading" absolute />

    <transaction-auth
      v-if="!isSettingsLoading && authEnabled && !isAuth"
      type="receive"
      @updateAuth="updateAuth"
      @updateTransactionInfo="updateTransactionInfo"
      @updateReceiver="updateReceiver"
    />

    <template v-if="!isSettingsLoading && showForm">
      <div class="d-flex justify-space-between mb-3">
        <v-btn
          :loading="isCancelLoading"
          class="button-back transaction-button"
          @click="goBack"
        >
          <font-awesome-icon icon="chevron-left" />
          Назад
        </v-btn>
        <v-btn
          :loading="isLoading"
          :disabled="!canSave"
          class="button-success button-accept transaction-button d-none d-sm-inline-block"
          @click="applyTransaction"
        >
          <font-awesome-icon icon="check" />
          Сохранить
        </v-btn>
      </div>
      <v-row>
        <v-col sm="3" cols="12">
          <transaction-currency
            v-model="currentCurrency"
            :transaction="transactionForBalance"
            hide-checks
            class="collection-transaction-currency"
          />
        </v-col>

        <v-col sm="5" cols="12">
          <transaction-calc v-model="amount" :transaction="transaction" />
        </v-col>

        <v-col v-if="authEnabled" sm="4" cols="12">
          <div class="collection-persons-container">
            <transaction-person :person="receiver" />
            <div class="d-flex justify-center">
              <font-awesome-icon class="arrow-down" icon="arrow-down" color="#FB8C00" />
            </div>
            <transaction-person :person="sender" />
          </div>
        </v-col>
      </v-row>
      <div class="d-sm-none">
        <v-btn
          :loading="isLoading"
          :disabled="!canSave"
          class="button-success button-accept transaction-button"
          @click="applyTransaction"
        >
          <font-awesome-icon icon="check" />
          Сохранить
        </v-btn>
      </div>
    </template>

    <modal-results :show="showResults" @close="close" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TransactionCalc from '../../transaction-components/transaction-calc/TransactionCalc'
  import TransactionPerson from '../TransactionPerson'
  import TransactionCurrency from '../../transaction-components/transaction-currency/TransactionCurrency'
  import TransactionAuth from '../TransactionAuth'
  import ModalResults from '../ModalResults'
  import VLoader from '@/components/loader/Loader'
  import mixinTransactions from '@/mixins/transactions'

  export default {
    name: 'Replenishment',
    components: {
      TransactionCalc,
      TransactionPerson,
      TransactionCurrency,
      TransactionAuth,
      ModalResults,
      VLoader,
    },
    mixins: [mixinTransactions],
    data () {
      return {
        isSettingsLoading: true,
        authEnabled: true,
        cashBalance: null,
        isAuth: false,
        isCancelLoading: false,
        isLoading: false,
        amount: 0,
        currentCurrency: 'cash',
        transaction: {},
        receiver: {},
        sender: {},
        showResults: false,
      }
    },
    computed: {
      ...mapGetters({
        localStorageBranch: 'branches/getLocalStorageBranch',
      }),
      showForm () {
        return this.authEnabled ? this.isAuth : true
      },
      transactionForBalance () {
        if (this.authEnabled) return this.transaction
        return {
          senderBalance: {
            cashBalance: this.cashBalance,
            terminalChecksBalance: 0,
            terminalChecksQuantity: 0,
          },
        }
      },
      canSave () {
        return Number(this.amount) > 0
      },
    },
    mounted () {
      this.loadSettings()
    },
    beforeDestroy () {
      this.cancelTransaction()
    },
    methods: {
      async loadSettings () {
        this.isSettingsLoading = true
        try {
          const settings = await this.$store.dispatch('transactions/fetchTransactionsSettings', {
            filialId: this.localStorageBranch.id,
          })
          this.authEnabled = !!settings.incomingAuthEnabled
          this.cashBalance = settings.cashBalance ?? null
        } catch (err) {
          this.showErrorFromResponse(err)
        } finally {
          this.isSettingsLoading = false
        }
      },
      goBack () {
        if (this.authEnabled) {
          this.cancelTransaction()
        } else {
          this.$emit('close')
        }
      },
      cancelTransaction () {
        const id = this.transaction?.id
        if (!id) return
        this.$store.dispatch('transactions/cancelTransaction', id)
          .then(res => {
            if (res.status === 200) {
              this.transaction = {}
              this.isAuth = false
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      applyTransaction () {
        this.isLoading = true

        const request = this.authEnabled
          ? this.$store.dispatch('transactions/completeCollectionType', {
            id: this.transaction.id,
            data: { price: this.amount },
          })
          : this.$store.dispatch('transactions/createCollectionType', {
            filialId: this.localStorageBranch.id,
            type: 'receive',
            price: this.amount,
          })

        request
          .then(res => {
            if (res.status === 200) {
              if (!this.authEnabled) this.transaction = {}
              this.showResults = true
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          }).finally(() => {
            this.isLoading = false
          })
      },
      updateAuth (value) {
        this.isAuth = value
      },
      updateReceiver (value) {
        this.receiver = JSON.parse(JSON.stringify(value))
      },
      updateTransactionInfo (value) {
        this.transaction = value
        this.sender = JSON.parse(JSON.stringify(value.sender))
      },
      close () {
        this.isAuth = false
        this.transaction = {}
        this.sender = {}
        this.receiver = {}
        this.$emit('close')
      },
    },
  }
</script>

<style lang="less" scoped>
  .collection-component {
    min-height: calc(100vh - 230px);
    position: relative;

    .button-back {
      max-width: 350px;
      width: 100%;
    }
    .button-accept {
      max-width: 350px;
      width: 100%;
      svg {
        margin-right: 12px;
      }
      .media-sm({
        margin-bottom: 20px;
      });
    }

    .transaction-button {
      box-shadow: 0 3px 6px #00000029 !important;

      .media-sm({
        display: block;
        width: 100%;
        min-width: 100%;
      })
    }

    .arrow-down {
      width: 60px;
      height: 60px;
      margin: 20px 0;
    }

    .button {
      border-radius: 10px;
      height: 60px;
      font-size: 18px;
      background-color: @color-secondary !important;

      &.button-cancel {
        vertical-align: middle;
        margin-bottom: 24px;

        svg {
          width: 20px;
          height: 100%;
          margin-right: 20px;
          .fill-svg(@color-error);
        }
      }
    }

    .label {
      display: block;
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 500;
    }

    .cash-section,
    .terminal-section {
      border-radius: 5px;
      padding: 10px 15px;

      span {
        display: block;
      }
    }

    .text-field {
      &.v-input--is-focused {
        ::v-deep {
          .v-input__slot {
            border: 2px solid #ff9500;
          }
        }
      }

      &.error--text {
        ::v-deep {
          .v-input__slot {
            border: 2px solid @color-error;
          }
        }
      }

      ::v-deep {
        .v-input__slot {
          height: 80px;
          background-color: @color-secondary;
          border-radius: 15px;

          input {
            font-size: 25px;
            line-height: 18px;
          }
        }
      }
    }

    .collection-persons {
      margin-bottom: 10px;

      svg {
        margin: 0 24px;
      }
    }

    .replenishment-section {
      .display-3 {
        line-height: 1;
        display: block;
        margin-bottom: 24px;
      }

      .checks {
        flex: 1;
        height: 60px;
        margin-right: 10px;
        background-color: @color-secondary;
        border-radius: 5px;

        span {
          font-size: 24px;
          line-height: 1;
        }
      }

      .button-replenishment {
        max-width: 100px;
        width: 100%;

        &:last-child {
          margin-left: 10px;
        }

        svg {
          .fill-svg(@color-primary);
        }
      }
    }
    .collection-transaction-currency {
      ::v-deep {
        .cash-section {
          margin-top: 6px;
        }
      }
    }

    .collection-persons-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 100%;
      padding: 6px 0;
    }
  }
</style>
